import { Button, Checkbox, Col, Form, Input, Row } from 'antd'
import { TimelineApi } from '../../../api/Timeline'
import Fade from '../../../elements/Fade'
import useSubmit from '../../../elements/Hooks/useSubmit'
import React from 'react'
import { defaultFormItemLayout } from '../../../modules/FormItems'

const { TextArea } = Input

// const formRef = React.createRef()

function Editor(props) {
  const { getFieldDecorator } = props.form
  // const formRef = useRef()
  const { show, postId, fetch, owner, hideNotification, submitNotification } = props
  // const [timeline, setTimeline] = useState({})
  //
  // const [updating, updateFunc] = useSubmit(TimelineApi.update)
  //
  function checkForm() {
    return new Promise((res, rej) => {
      props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(TimelineApi.create)


  async function submit() {
    const values = await checkForm()
    let data = { ...values }
    data.owner = { _id: owner }
    if (postId) {
      data.post = { _id: postId }
      data.type = 'child'
    } else {
      data.type = 'parent'
    }

    const submitted = await submitFunc(data)
    submitNotification && submitNotification(data)
    if (submitted) fetch()
  }

  // async function update () {
  //   const values = await checkForm()
  //   const timelineDB = await updateFunc({
  //     ...pick(timeline, ['_key', '_id', '_rev']),
  //     ...values,
  //   })
  //   if (timelineDB) setTimeline(timelineDB)
  // }
  //
  // const [removing, removeFunc] = useSubmit(TimelineApi.remove)
  //
  // async function remove () {
  //   const removed = await removeFunc({
  //     ...pick(timeline, ['_key', '_rev', '_id']),
  //   })
  //   if (removed)
  //     props.history.replace({
  //       pathname: `/operations/timeline-system/`,
  //     })
  // }

  return (
    <Fade show={postId ? show === postId : show}>
      <Form>
        <Row>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator('comment', {
                initialValue: '',
                //rules: rules.select,
              })(<TextArea rows={4} />)}
            </Form.Item>
          </Col>
        </Row>
        {!hideNotification === true && (
          <Row>
            <Col span={12} style={{ align: 'center' }}>
              <Form.Item
                {...defaultFormItemLayout}
                label="Send Notification"
                style={{ fontWeight: 'bold', color: 'red' }}>
                {getFieldDecorator('sendEmail', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={12} style={{ textAlign: 'center' }}>
            <Form.Item {...defaultFormItemLayout}>
              <Button htmlType="submit" loading={submitting} onClick={submit} type="primary">
                Add Comment
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Fade>
  )
}

export default Form.create()(Editor)
